import React, {useCallback , useState } from "react";
import axios from "axios";
import { Toolbar, useRedirect, useNotify, DeleteButton, fetchStart, fetchEnd } from "react-admin";
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from 'react-final-form';
import { rawFileExtraction } from "../../dataProvider";
import { useDispatch } from 'react-redux';
import { apiUrl } from "../../dataProvider";

const useStyles = makeStyles(() => ({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}));

const CustomSave = ({ handleSubmitWithRedirect, resource, action, ...props }) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const redirectTo = useRedirect();
    const notify = useNotify();
    const { basePath } = props;
    const form = useForm();
    const tags = props.chipData.map(chip => chip.label);
    form.change("newTags", tags);
    let axiosConfig = {
        headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
        }
    };

    const imageUrlToBase64 = async (imageUrl) => {
        const response = await fetch(imageUrl);
        if (!response.ok) throw new Error("Image fetch failed");
        const blob = await response.blob();
        const contentType = response.headers.get('content-type') || 'image/png';
        // Extract the filename from the imageUrl if possible
        const originalFilename = imageUrl.split('/').at(-1)
        return new File([blob], originalFilename, { type: contentType });
      };

    const handleClick = useCallback(async () => {
        setLoading(true);
        dispatch(fetchStart());

        const values = form.getState().values;

        if(action === 'edit') {
            const {
                employee_price,
                wholesale_price,
                retail_price,
                category_id,
                newTags,
                pictures,
                ...remainder
            } = values;
            // const files = await Promise.all(pictures.map(async i => {
            //     if(typeof i === 'string') {
            //         const blob = await imageUrlToBase64(i);
            //         return blob;
            //     } else {
            //         return i
            //     }
            // }))
            const convertedPrices = {
                employee_price: Number(employee_price.replace(/[^0-9\.]+/g, "")),
                wholesale_price: wholesale_price ? Number(wholesale_price.replace(/[^0-9\.]+/g, "")) : null,
                retail_price: Number(retail_price.replace(/[^0-9\.]+/g, ""))
            };
            let editData = {
                ...remainder,
                ...convertedPrices,
                categories: category_id,
                tags: newTags,
                non_ring: values.non_ring ? 1 : 0,
                pictures,
                _method: "PUT"
            };

            const formData = await rawFileExtraction(editData);
            axios
                .post(`${apiUrl}/${resource}/${props.record.id}`, formData, axiosConfig)
                .then(({ data }) => {
                    notify('Product Updated');
                    redirectTo(basePath);
                    return ({
                    data
                })
                })
                .catch(({response: {data: {errors}}}) => {
                    const message = errors[Object.keys(errors)[0]][0];
                    notify(message, 'warning')
                })
                .finally(() => {
                    setLoading(false);
                    dispatch(fetchEnd());
                });
        }

        if(action === 'create') {
            const { data: {category_id, ...remaining}, newTags } = values;
            let cleanData = {
                ...remaining,
                categories: category_id,
                tags: newTags,
                non_ring: values?.non_ring ? 1 : 0,
                pictures: values?.pictures,
            };

            if (values.non_ring) {
                cleanData = {
                    non_ring: values?.non_ring ? 1 : 0,
                    categories: category_id,
                    ring_material: values?.data?.ring_material,
                    sku: values?.data?.sku,
                    wholesale_price: values?.data?.wholesale_price ? Number(values?.data?.wholesale_price.replace(/[^0-9\.]+/g, "")) : null,
                    active: values?.data?.active,
                    description: values?.data?.description,
                    nc_magic_number: values?.nc_magic_number,
                    tags: values?.newTags,
                    pictures: values?.pictures,
                    image_url: values?.data?.image_url
                }
            }


            const formData = await rawFileExtraction(cleanData);
            axios
                .post(`${apiUrl}/${resource}`, formData, axiosConfig)
                .then(response => {
                    notify('Product Added');
                    redirectTo(basePath);
                    return {
                        data: {
                            ...response.data
                        }
                    };
                })
                .catch(({response: {data: {errors}}}) => {
                    const message = errors[Object.keys(errors)[0]][0];
                    notify(message, 'warning')
                })
                .finally(() => {
                    setLoading(false);
                    dispatch(fetchEnd());
                });
        }
    },[form]);

    return <Button
        {...props}
        disabled={form.getState().hasValidationErrors || loading}
        onClick={handleClick}
        startIcon={<SaveIcon/>}
    >
        Save
    </Button>;
};

const CreateToolbar = props => {
    const classes = useStyles();
       return <Toolbar {...props} className={classes.toolbar}>
            <CustomSave
                redirect="list"
                submitOnEnter={false}
                variant="text"
                {...props}
            />
            <DeleteButton undoable={false} />
        </Toolbar>
};

export default CreateToolbar;